export default __webpack_public_path__ + "static/media/blackK8s.d12bd082.svg";